export const subtitles = {
    "1": {
        "startTime": 2.0,
        "endTime": 6.8,
        "transcript": "Arenqiatua wii, iika assiilami-ll'. Qitngiryugtua.",
        "translation": "I'm struggling, also because my eye is bad. The light is bright for me."
    },
    "2": {
        "startTime": 7.0,
        "endTime": 10.0,
        "transcript": "Tang at' black-aagnek ackiinrilama. (Akleng.)",
        "translation": "I wish I had black sunglasses. (I'm sorry.)"
    },
    "3": {
        "startTime": 17.0,
        "endTime": 18.0,
        "transcript": "Alright.",
        "translation": "Alright."
    },
    "4": {
        "startTime": 18.5,
        "endTime": 26.0,
        "transcript": "Talking with Paul G. and Lucy Nicholai for the record just in case we don't know who they are sometimes.",
        "translation": "Talking with Paul G. and Lucy Nicholai for the record just in case we don't know who they are sometimes."
    },
    "5": {
        "startTime": 26.8,
        "endTime": 32.5,
        "transcript": "(Yugtun-llu.) Yugtun-llu Cialuq and… Yugcetun ima?",
        "translation": "(In Yup'ik too.) And in Yup'ik, Cialuq and… what's your Yup'ik name again?"
    },
    "6": {
        "startTime": 34.6,
        "endTime": 40.0,
        "transcript": "Atpiaqa-w' Qakvaralriaruyaaqell' tau͡gaam amaqliirutka yuunrillrani",
        "translation": "My real name is Qakvaralria, but when my late older brother passed away"
    },
    "7": {
        "startTime": 40.6,
        "endTime": 43.9,
        "transcript": "Ciin-tam-kiq tam' cimirtatgu?",
        "translation": "I wonder why they changed it?"
    },
    "8": {
        "startTime": 44.3,
        "endTime": 47.5,
        "transcript": "Neviarmek pilaraatnga maa-i. (Ii-i, yaa, okay.)",
        "translation": "Now, they call me Neviar. (I see, yes, okay.)"
    },
    "9": {
        "startTime": 48.5,
        "endTime": 51.0,
        "transcript": "Atra-w' Kass'atun nallunritliken. (Ii-i, yaa.)",
        "translation": "You probably know her English name. (Yes, yes.)"
    },
    "10": {
        "startTime": 51.1,
        "endTime": 54.0,
        "transcript": "Yaa, nallungailken.",
        "translation": "Yes, there's no way you wouldn't know."
    },
    "11": {
        "startTime": 54.1,
        "endTime": 67.5,
        "transcript": "Yaa. Tua-ll' Cialuq ciumek mat'um maa-i-rpak up'nerkartuq qakemna ellavut.",
        "translation": "Yes. And then Cialuq first, the season around us is spring now."
    },
    "12": {
        "startTime": 68.4,
        "endTime": 83.0,
        "transcript": "Tua-ll' inerquutertangqelallruut-qaa tamakut yullret nalliitni up'nerkami atullerkaitnek?",
        "translation": "Were there admonishments in the time of people back then that they should follow in the spring?"
    },
    "13": {
        "startTime": 84.0,
        "endTime": 87.0,
        "transcript": "Canek-wa tua. Tua-i tau͡gaam waten…",
        "translation": "Various things. This was the only…"
    },
    "14": {
        "startTime": 90.0,
        "endTime": 92.0,
        "transcript": "So they're talking with this camera.",
        "translation": "So they're talking with this camera."
    },
    "15": {
        "startTime": 92.7,
        "endTime": 94.0,
        "transcript": "Ii-i.",
        "translation": "Okay."
    },
    "16": {
        "startTime": 95.5,
        "endTime": 96.5,
        "transcript": "Ii-i, kitaki.",
        "translation": "Okay, proceed."
    },
    "17": {
        "startTime": 96.6,
        "endTime": 99.4,
        "transcript": "Yaa, right around here then they're talking with [us]. (Ii-i.)",
        "translation": "Yes, right around here then they're talking with [us]. (Okay.)"
    },
    "18": {
        "startTime": 99.5,
        "endTime": 103.9,
        "transcript": "Waten tua-i au͡gkut, elpet-llu-w' tua-i nallunrilketen",
        "translation": "They [said] this, and you know them too"
    },
    "19": {
        "startTime": 104.0,
        "endTime": 110.5,
        "transcript": "Au͡gkut aulukestellemta up'nerka'rqan, up'nerka'rqan waten",
        "translation": "Our caretakers back then when spring set, when spring set like this"
    },
    "20": {
        "startTime": 111.8,
        "endTime": 116.8,
        "transcript": "Tua-i cikuliurutraq nantesqevkenaku iinguan.",
        "translation": "They would tell us to always have an ice spud because it's our eyes."
    },
    "21": {
        "startTime": 117.5,
        "endTime": 120.5,
        "transcript": "Tua-i ilumun tua elpet-llu nallunrilken tua-i.",
        "translation": "Indeed, you know it too."
    },
    "22": {
        "startTime": 123.5,
        "endTime": 125.4,
        "transcript": "Allayugmek pitaituq.",
        "translation": "There's nothing else."
    },
    "23": {
        "startTime": 125.5,
        "endTime": 134.0,
        "transcript": "Tua-i tau͡gaam waten tua-i ak'allarraat tua-i ak'allaraat tua-i aaryuitesqevkenata alerqunqegcaaratullruitkut.",
        "translation": "The old people, the old people only made completely sure to admonish us against being reckless."
    },
    "24": {
        "startTime": 137.8,
        "endTime": 139.5,
        "transcript": "Yugcetun ima caulriaten cali?",
        "translation": "Who were you in Yup'ik again?"
    },
    "25": {
        "startTime": 140.0,
        "endTime": 141.8,
        "transcript": "Nev'aq. (Nev'aq, yaa.)",
        "translation": "Nev'aq. (Nev'aq, okay.)"
    },
    "26": {
        "startTime": 142.0,
        "endTime": 143.9,
        "transcript": "Neviaq. (Neviaq.)",
        "translation": "Neviaq. (Neviaq.)"
    },
    "27": {
        "startTime": 144.0,
        "endTime": 146.5,
        "transcript": "Neviar. (Ii-i, Neviar.)",
        "translation": "Neviar. (Okay, Neviar.)"
    },
    "28": {
        "startTime": 147.5,
        "endTime": 158.0,
        "transcript": "Ak'a-wa tamaani elpet ilaten nasaurlullraullerpeni maligtelallrulliketen up'nerkiyaraqata.",
        "translation": "Back when you were a girl, you probably went with your family when they went to spring camp."
    },
    "29": {
        "startTime": 158.7,
        "endTime": 163.5,
        "transcript": "Tamatumek-qaa qanqeryuumiiten piciatun tamatum tungiinun?",
        "translation": "Do you want to say anything concerning that?"
    },
    "30": {
        "startTime": 164.3,
        "endTime": 171.0,
        "transcript": "Up'nerkiyaqamta-wa waten Arnangiaraller nalluksi Iqalluunkut aanallrat",
        "translation": "When we went to spring camp like this, youpl don't know Arnangiaraller, the mother of the late Iqalluk and famiuly"
    },
    "31": {
        "startTime": 171.5,
        "endTime": 178.0,
        "transcript": "Waten pitullrukiikut ayaganguaqtaqatarqamta natmun yuilqurrarmun:",
        "translation": "She would say this to us when we would travel about in the wilderness:"
    },
    "32": {
        "startTime": 178.2,
        "endTime": 190.5,
        "transcript": "“Ayarulgirluci. Atam pitsaqevkenaci igpallakuvci-llu ayaruq cani'irrluku nugutekniarci.”",
        "translation": "“Take a walking staff. You see, if you should even trip, you can get out [of water] by putting the staff on its side.”"
    },
    "33": {
        "startTime": 192.0,
        "endTime": 193.3,
        "transcript": "Tuaten pilallruakut.",
        "translation": "She used to tell us that."
    },
    "34": {
        "startTime": 193.5,
        "endTime": 197.5,
        "transcript": "Tuar uum nallunrilkai Yuut piyarait.",
        "translation": "It seems he knows about Yup'ik ways."
    },
    "35": {
        "startTime": 198.0,
        "endTime": 204.4,
        "transcript": "Ilaitni-llu atakumi niitelallruunga nepailcaaralaasqelluki.",
        "translation": "Sometimes, I've also heard them say to be quiet in the evning."
    },
    "36": {
        "startTime": 204.5,
        "endTime": 206.0,
        "transcript": "Yaa. (Ciin tanem?)",
        "translation": "Yes. (Why?)"
    },
    "37": {
        "startTime": 207.4,
        "endTime": 213.8,
        "transcript": "Tua-i-w' pitullrukiikut cali nepaunata pilaasqelluta.",
        "translation": "They told us to be quiet."
    },
    "38": {
        "startTime": 214.0,
        "endTime": 218.0,
        "transcript": "Atam-gguq, nepengyarniaraakut-gguq atam.",
        "translation": "They said, you see, that the nepengyaq would be attracted by our noise."
    },
    "39": {
        "startTime": 220.0,
        "endTime": 222.0,
        "transcript": "Cam tanem? (Carayiim.)",
        "translation": "What? (A ghost.)"
    },
    "40": {
        "startTime": 230.8,
        "endTime": 244.6,
        "transcript": "Cali ukut-qaa Kuigglugmiut ayalallermeggni up'nerkiyarvimeggnun wall'u-qaa pissuryaraqameng",
        "translation": "Also, when the people from Kwethluk would go to their spring camps or when they went hunting"
    },
    "41": {
        "startTime": 245.0,
        "endTime": 247.0,
        "transcript": "Yuirut'lallruut-qaa ak'a tamaani?",
        "translation": "Would there be no one left a long time ago?"
    },
    "42": {
        "startTime": 248.0,
        "endTime": 251.4,
        "transcript": "Mayurluteng. Amlleq-gguq unegcuitellruuq.",
        "translation": "They went up. They said not many stayed behind."
    },
    "43": {
        "startTime": 251.5,
        "endTime": 254.8,
        "transcript": "Wii tamakut nallullruanka ciuqvaat au͡gkut.",
        "translation": "I didn't know about those old things back then."
    },
    "44": {
        "startTime": 255.0,
        "endTime": 259.0,
        "transcript": "Amllermek-gguq una yungqessuitellruuq Kuiggluk",
        "translation": "They said that there weren't a lot of people in Kwethluk"
    },
    "45": {
        "startTime": 259.7,
        "endTime": 265.5,
        "transcript": "Tua-i, tua-i angussaagarluteng pitullruameng ciulirneret qanganaarnek.",
        "translation": "Because [our] ancestors would hunt for ground squirrels."
    },
    "46": {
        "startTime": 265.7,
        "endTime": 268.8,
        "transcript": "Tua-i tamaa-i yuungnaqutait.",
        "translation": "That's what their subsistence."
    },
    "47": {
        "startTime": 270.5,
        "endTime": 275.5,
        "transcript": "Maa-i wangkuta aturciigataput au͡gkut catairutellret.",
        "translation": "We can't live those old ways that were lost."
    },
    "48": {
        "startTime": 275.6,
        "endTime": 278.5,
        "transcript": "Tua-i elpet-llu nallunrilketen tua-i.",
        "translation": "You probably know them."
    },
    "49": {
        "startTime": 280.3,
        "endTime": 285.0,
        "transcript": "Tua-i paigurallemteńi tua-i wii ayayuirutua [Qulmun].",
        "translation": "As we always babysit, I don't go to [Qula] anymore."
    },
    "50": {
        "startTime": 287.4,
        "endTime": 293.3,
        "transcript": "Maani-qaa Kuiggluum avatiini pitarkat amllerralallruut tamaani?",
        "translation": "Were there a lot of animals they hunted around Kwethluk back then?"
    },
    "51": {
        "startTime": 293.4,
        "endTime": 303.0,
        "transcript": "Aren, enurnaitellruut ciuqvani imkut au͡gkut aulukestelput taluyarteggun kapkaanarteggun-llu.",
        "translation": "My goodness, they were not scarce when our late caretakers [set] fish traps and animal traps."
    },
    "52": {
        "startTime": 303.5,
        "endTime": 309.0,
        "transcript": "Kapkaanaliyuitellruama qavcirrarnek kapkaanangqetullruama, unisteka-w' imna.",
        "translation": "I didn't set animal traps because I only had a few [from] my late father."
    },
    "53": {
        "startTime": 310.5,
        "endTime": 316.9,
        "transcript": "Tua-i Kass'atun maa-i makut Kass'at Yugtun ayuqenriqait",
        "translation": "Like Westerners, these Westerners are making these [people] unlike Yupiit [back then]"
    },
    "54": {
        "startTime": 317.0,
        "endTime": 321.5,
        "transcript": "Tua-i kapkaanarnek taluyaarnek-llu, taluyarkanek.",
        "translation": "[Using] animal traps and fish traps, material for fish traps [back then]."
    },
    "55": {
        "startTime": 322.5,
        "endTime": 326.5,
        "transcript": "Tua-i tamaa-i wiinga-am tua-i maa-i cali taluyartuqtaumaunga",
        "translation": "I am still doing that now with a fish trap"
    },
    "56": {
        "startTime": 326.6,
        "endTime": 329.0,
        "transcript": "Imanganek-wa tau͡gaam.",
        "translation": "Only for black fish."
    },
    "57": {
        "startTime": 333.8,
        "endTime": 344.5,
        "transcript": "Ak'a tamaani-qaa yuut piciryarangqelallruut pitat merriartaqluki mermek?",
        "translation": "A long time ago, did people have a tradition of giving water to animals they had caught?"
    },
    "58": {
        "startTime": 345.6,
        "endTime": 349.4,
        "transcript": "Unkumiutaat. Unkumiutaat. (Aku'urrluki, aku'urrluki, ii-i.)",
        "translation": "Animals from the coast. Animals from the cause. (They dipped them, they dipped them, yes.)"
    },
    "59": {
        "startTime": 350.4,
        "endTime": 362.0,
        "transcript": "Tanglallruunga, nalluketen-llu teptukuyiit, iciw' evv'laavat aciit assirluteng narellrit qengaitnun piqerluki",
        "translation": "I used to see, and you probably don't know valerians, you know, the roots of flowes that smell nice placed on their noses"
    },
    "60": {
        "startTime": 363.3,
        "endTime": 366.4,
        "transcript": "Neqrarrmek-llu wall' merr'armek piluki.",
        "translation": "And they give them a little food or water."
    },
    "61": {
        "startTime": 367.5,
        "endTime": 369.8,
        "transcript": "Tua-i-w' tamalkuita pitullrullikait.",
        "translation": "They probably did that to all [animals]."
    },
    "62": {
        "startTime": 370.0,
        "endTime": 375.0,
        "transcript": "Wii ak'allaqapiaraat nalluanka. Tau͡gaam…",
        "translation": "I don't know the very old ways. But…"
    },
    "63": {
        "startTime": 375.1,
        "endTime": 377.9,
        "transcript": "Ciin tanem tuaten pilallruitki?",
        "translation": "Why did that do that to them?"
    },
    "64": {
        "startTime": 378.0,
        "endTime": 380.0,
        "transcript": "Allanilluki-gguq.",
        "translation": "They said they treated them as guests."
    },
    "65": {
        "startTime": 380.8,
        "endTime": 382.5,
        "transcript": "Allanisnguarluki-w'.",
        "translation": "They pretended to receive them as guests."
    },
    "66": {
        "startTime": 382.6,
        "endTime": 389.5,
        "transcript": "Atam imumi-ll' maani pitullruut imkut neqet piurluki, qanritnun-llu iqmiliqaulluki.",
        "translation": "You see, they also did that a long time ago to fish, and putting [food or tobacco] in their mouths."
    },
    "67": {
        "startTime": 390.5,
        "endTime": 391.4,
        "transcript": "Unkumiutaat.",
        "translation": "Animals from the coast."
    },
    "68": {
        "startTime": 391.5,
        "endTime": 395.9,
        "transcript": "Tangvaksaitellruuten? Wangkuta imumi pitullruukut.",
        "translation": "Have you ever seen that? We used to do that a long time ago."
    },
    "69": {
        "startTime": 396.4,
        "endTime": 402.0,
        "transcript": "Mikluta, sugtuv[kenii], wii miklua mikluta elliraurtellruamta.",
        "translation": "We were small, I wasn't tall, I was small because we were orphaned when we were small."
    },
    "70": {
        "startTime": 402.7,
        "endTime": 406.5,
        "transcript": "Yaa, wiinga-ll'… apteksaitaanga.",
        "translation": "Yes, me too… he didn't ask me."
    },
    "71": {
        "startTime": 408.0,
        "endTime": 423.0,
        "transcript": "Tua-ll' Neviar, ak'a tamaani makut nasaurluut aglenrraraat",
        "translation": "And then Neviar, these girls in the year of their first menstruations a long time ago"
    },
    "72": {
        "startTime": 429.3,
        "endTime": 431.0,
        "transcript": "Maani-llu-qaa Kuigglugmi wall'u-qaa?",
        "translation": "Did they do it here in Kwethluk too or what?"
    },
    "73": {
        "startTime": 431.1,
        "endTime": 434.4,
        "transcript": "Piyuirutut. (Aqumgavkalallruit?)",
        "translation": "They don't anymore. (Did they separate them from society?)"
    },
    "74": {
        "startTime": 435.0,
        "endTime": 443.3,
        "transcript": "Wiinga-w' tang imumi qanraqluteng eyagcetenritaatnga-gguq mayiteqciryuumiilameg[teńga].",
        "translation": "Personally, you see, a long time ago, they would say that they didn't have me abstain because they didn't want me to be destitute."
    },
    "75": {
        "startTime": 443.4,
        "endTime": 447.9,
        "transcript": "Amta-ll' eyagcellua ayagavkaqsaunii-llu.",
        "translation": "And yet they had me abstain and kept me from traveling a lot."
    },
    "76": {
        "startTime": 450.8,
        "endTime": 458.5,
        "transcript": "Tua-i-ll' cali upakataamta up'nerkillernek meq tang aramek milqerceskilitgu.",
        "translation": "And then when we were going to move from spring camps, they had me throw ash on into the water."
    },
    "77": {
        "startTime": 459.0,
        "endTime": 460.0,
        "transcript": "Tuaten.",
        "translation": "Like that."
    },
    "78": {
        "startTime": 461.0,
        "endTime": 462.5,
        "transcript": "Cauga tamana? (Taringenritliuq.)",
        "translation": "What is that? (He might not understand.)"
    },
    "79": {
        "startTime": 463.8,
        "endTime": 466.6,
        "transcript": "Meq… araq-qaa nalluan? Iciw' kaminiat…",
        "translation": "The water… do you know what araq is? You know, from stoves…"
    },
    "80": {
        "startTime": 466.7,
        "endTime": 468.9,
        "transcript": "Qamlleq. Qamlleq-wa. (Qamlleq.)",
        "translation": "Where the fire had gone out. Where the fire had gone out. (Where the fire had gone out.)"
    },
    "81": {
        "startTime": 473.5,
        "endTime": 474.6,
        "transcript": "Canaluku-gguq?",
        "translation": "What was the reason?"
    },
    "82": {
        "startTime": 475.0,
        "endTime": 478.5,
        "transcript": "Tua-i-w' piciryaraqlikiit au͡gkut ciulirneret tamakut. (Naamell', piciryaraqluku-w' tua-i.)",
        "translation": "That's probably the custom of [our] ancestors back them. (I don't know, it's their custom.)"
    },
    "83": {
        "startTime": 479.0,
        "endTime": 480.8,
        "transcript": "Uum nallullikii.",
        "translation": "She probably doesn't know."
    },
    "84": {
        "startTime": 482.0,
        "endTime": 487.0,
        "transcript": "Ciuliamta piciryaraqluku eyatullermeggni. (Ii-i, qayumi ciuliam piciryaraqaa.)",
        "translation": "It was our ancestors' custom when they abstained. (Yes, as expected, our ancestors' custom.)"
    },
    "85": {
        "startTime": 487.4,
        "endTime": 490.0,
        "transcript": "Eyayuirutut-gguq maa-i. Eyayuirutut.",
        "translation": "They say they don't abstain anymore now. They don't abstain anymore."
    },
    "86": {
        "startTime": 490.1,
        "endTime": 492.0,
        "transcript": "Eyalriamek wii tangeqsaitua.",
        "translation": "I haven't seen anyone abstaining."
    },
    "87": {
        "startTime": 493.0,
        "endTime": 497.0,
        "transcript": "Pagna-ll' tangaasqeksaunaku aglenraraugaqamta.",
        "translation": "They also told us not to look up [at the sky] during the year of our first menstruations."
    },
    "88": {
        "startTime": 497.9,
        "endTime": 499.0,
        "transcript": "Ciin tanem?",
        "translation": "Why?"
    },
    "89": {
        "startTime": 500.0,
        "endTime": 502.5,
        "transcript": "Iingiucara'arnayukluta-gguq.",
        "translation": "They said we might lose our eyesight early."
    },
    "90": {
        "startTime": 506.0,
        "endTime": 508.0,
        "transcript": "Tua-i-w' tauten.",
        "translation": "That's how it was."
    },
    "91": {
        "startTime": 517.0,
        "endTime": 518.0,
        "transcript": "Makut…",
        "translation": "These…"
    },
    "92": {
        "startTime": 524.3,
        "endTime": 529.5,
        "transcript": "Cali qanrutkelallruit-am tamakut, ilaitni-llu maa-i-rpak niitelartua waten.",
        "translation": "They also talked about those, and I hear about this sometimes now."
    },
    "93": {
        "startTime": 529.6,
        "endTime": 534.0,
        "transcript": "Kat'um Paseqam qanrusngualaraanga-am",
        "translation": "Paseqaq down there tells me"
    },
    "94": {
        "startTime": 535.3,
        "endTime": 538.4,
        "transcript": "Manalriit-gguq uumi tua-i cang'aqluteng",
        "translation": "That people jigging now catch fish"
    },
    "95": {
        "startTime": 538.5,
        "endTime": 547.0,
        "transcript": "Tua-i-llu-gguq-am iliit nasaurluut-gguq-am iliit qaill' pillruami",
        "translation": "And then he said that when one of the girls did something"
    },
    "96": {
        "startTime": 548.0,
        "endTime": 550.9,
        "transcript": "Manaryallrani-gguq-am imkut neqet ayemqertut.",
        "translation": "When she fished, they said that the fish “broke.”"
    },
    "97": {
        "startTime": 551.0,
        "endTime": 552.0,
        "transcript": "Cauga tamana?",
        "translation": "What's that?"
    },
    "98": {
        "startTime": 552.5,
        "endTime": 559.0,
        "transcript": "Aglenraraat irnicuallret-llu pisqessuitait. (Tua-i taukuk qanrutkelallrit au͡gkut.)",
        "translation": "They tell girls within the year of their first menstruations and those who miscarried not to. (The people back then talked about those.)"
    },
    "99": {
        "startTime": 560.0,
        "endTime": 563.0,
        "transcript": "Nalluyuitelliniit neqngung'e'rmeng.",
        "translation": "Even the fish know [that] they [had gone]."
    },
    "100": {
        "startTime": 566.9,
        "endTime": 570.3,
        "transcript": "Tua-i-qaa tauna kiingan inerquutekaat neqnun?",
        "translation": "Is that the only admonishment for fish?"
    },
    "101": {
        "startTime": 570.4,
        "endTime": 572.8,
        "transcript": "Tua-i waten qanrutkelaqiit.",
        "translation": "They talk about it like this."
    },
    "102": {
        "startTime": 572.9,
        "endTime": 576.5,
        "transcript": "Arimat-llu, arimat-llu qassasqevkenaki.",
        "translation": "And spoiled food, they told them not to eat spoiled food raw."
    },
    "103": {
        "startTime": 579.5,
        "endTime": 582.0,
        "transcript": "Aripat-wa pillikai. (Yaa.)",
        "translation": "She's talking about spoiled food. (Yes.)"
    },
    "104": {
        "startTime": 583.8,
        "endTime": 586.5,
        "transcript": "Cali-ll' iqvaasqevkenaki aglenraraat.",
        "translation": "They also told girls within the year of the first menstruations not to pick berries."
    },
    "105": {
        "startTime": 587.0,
        "endTime": 591.5,
        "transcript": "Anllercuasqevkenaki, iqvaasqevkenaki.",
        "translation": "They told them not to dig for mouse caches or pick berries."
    },
    "106": {
        "startTime": 592.0,
        "endTime": 597.5,
        "transcript": "Eyagluteng-llu qaleqcuugnek qangqiirnek-llu kiingita nerluteng.",
        "translation": "They also abstained by eating only grebes and ptarmigans."
    },
    "107": {
        "startTime": 597.8,
        "endTime": 599.9,
        "transcript": "Wiinga-w' tuaten pillrulrianga.",
        "translation": "I personally did that."
    },
    "108": {
        "startTime": 600.0,
        "endTime": 606.0,
        "transcript": "Qaleqcuuk, qangqiiq neqenka, kiagcetallret-llu neqerrluaraat.",
        "translation": "I only ate grebes, ptarmigans, and dried fish from the previous year."
    },
    "109": {
        "startTime": 609.9,
        "endTime": 613.9,
        "transcript": "Nutaranek… (Piyuunata nutaranek.)",
        "translation": "Fresh [dried fish]… (We wouldn't eat fresh [dried fish].)"
    },
    "110": {
        "startTime": 614.8,
        "endTime": 620.5,
        "transcript": "Unkumiut atam eyakevkenaki yuvgerilata-gguq imarpigmiutaat.",
        "translation": "But they don't abstain from [fish] from the coast because they said that ones from the ocean don't have slime."
    },
    "111": {
        "startTime": 622.0,
        "endTime": 623.4,
        "transcript": "Puget-wa.",
        "translation": "Surfaced seals at least."
    },
    "112": {
        "startTime": 624.4,
        "endTime": 628.5,
        "transcript": "Issurit, maklaaret eyakevkenaki.",
        "translation": "They don't abstain from spotted or year-old bearded seals."
    },
    "113": {
        "startTime": 632.5,
        "endTime": 645.0,
        "transcript": "Makut, makut iralut, iralut maani Kuigglugmi Kusquqvagmi qaillun aptuitki ayagnirluku Iralull'e'rmek?",
        "translation": "What do they call these months, these months here in Kwethluk on the Kuskokwim starting from Iralull'er [January]?"
    },
    "114": {
        "startTime": 646.0,
        "endTime": 650.4,
        "transcript": "Wiinga Yugcetun nalluanka, tua-i au͡gkut tau͡gaam ciuqliit.",
        "translation": "I don't know them in Yup'ik except for the first ones."
    },
    "115": {
        "startTime": 650.5,
        "endTime": 659.8,
        "transcript": "Tua-i-w' Yugcetun-am ilait pilarait Yugtarnek aterpagtarluki, puqilriit-wa.",
        "translation": "Some call them by Yup'ik names, at least the fluent ones."
    },
    "116": {
        "startTime": 663.9,
        "endTime": 669.0,
        "transcript": "Aren, elpet-llu-w' ilait nallunritlikten Yugtarmek au͡gkut.",
        "translation": "I mean, you probably know some of them in Yup'ik too."
    },
    "117": {
        "startTime": 669.8,
        "endTime": 674.0,
        "transcript": "Igausngayaaqut tau͡gaam ilait ayuqsuitelarniit.",
        "translation": "They're written, but they say some aren't the same."
    },
    "118": {
        "startTime": 674.1,
        "endTime": 676.4,
        "transcript": "Yaa, qanelput-wa ayuqenrilameng.",
        "translation": "Yes, because our dialects are different."
    },
    "119": {
        "startTime": 676.5,
        "endTime": 679.8,
        "transcript": "Atam mallgut'nge'rmeng qanellgutkenritut.",
        "translation": "You see, they have different dialects even when they're close."
    },
    "120": {
        "startTime": 680.0,
        "endTime": 683.0,
        "transcript": "Tua-i nallunrilken elpet.",
        "translation": "You know that."
    },
    "121": {
        "startTime": 684.0,
        "endTime": 691.3,
        "transcript": "Tua-ll' ak'a tamaani agayuviit maani pissiyaangvailgata",
        "translation": "And then, a long time ago before churches became prevalent here"
    },
    "122": {
        "startTime": 692.0,
        "endTime": 697.0,
        "transcript": "Tungmagciaqameng yugnek akluit qungum qainganun ellilallruit.",
        "translation": "When they buried people, they would put their possessions on their graves."
    },
    "123": {
        "startTime": 697.7,
        "endTime": 700.8,
        "transcript": "Ciin, ciin tuaten pilallruat?",
        "translation": "Why did they do that?"
    },
    "124": {
        "startTime": 700.9,
        "endTime": 705.0,
        "transcript": "Imumi ciuqvani pitullruut, ciuqvani au͡gkut.",
        "translation": "They did that a long time ago, our ancestors back then."
    },
    "125": {
        "startTime": 705.5,
        "endTime": 710.0,
        "transcript": "Maa-i-ggem tua yuk tua-i ilaunri'rqan",
        "translation": "Now, when a person passes away"
    },
    "126": {
        "startTime": 710.5,
        "endTime": 714.7,
        "transcript": "Iciw' nallunrilketen-llu elpet tua-i aklullruarait ekualuki.",
        "translation": "You know, you also know that they burn their possessions."
    },
    "127": {
        "startTime": 714.8,
        "endTime": 719.9,
        "transcript": "Tua-i ekualuki nangluki. Tuaten maa-i piyaurtut. (Eggluki-llu.)",
        "translation": "They burned and destroyed them. They've started doing that now. (And throwing them away.)"
    },
    "128": {
        "startTime": 721.3,
        "endTime": 725.0,
        "transcript": "Au͡gkucetun, au͡gkut piciryarait atunrirait.",
        "translation": "They don't follow the old customs anymore."
    },
    "129": {
        "startTime": 727.4,
        "endTime": 734.0,
        "transcript": "Tamakut-gguq, iciw' piciatun egatet, saaniiget, yaaruitet, uyamiit",
        "translation": "They say that those, you know, various things, pots, kettles, storytelling knives, necklaces"
    },
    "130": {
        "startTime": 734.1,
        "endTime": 737.0,
        "transcript": "Alailutekluki-gguq qungumun.",
        "translation": "Those were grave markers."
    },
    "131": {
        "startTime": 739.0,
        "endTime": 740.5,
        "transcript": "Tuaten qanlallruut.",
        "translation": "That's what they used to say."
    },
    "132": {
        "startTime": 741.5,
        "endTime": 752.5,
        "transcript": "Avani-w' ciuqvani Kass'artailan tua-i ellaita yugurluut tua-i tua-i callruarait-llu ellimallratnun ellitullrulliniit.",
        "translation": "Because there were no Caucasians a long time ago, those people would put their few possessions where they were to be set."
    },
    "133": {
        "startTime": 752.6,
        "endTime": 757.0,
        "transcript": "Wiiinga-ll' yaani yuvrialallruanka nutellret tuaten.",
        "translation": "I also used to examine them over there, even old guns."
    },
    "134": {
        "startTime": 758.5,
        "endTime": 762.5,
        "transcript": "Tua-i yuunrirqata ellitulliniluki.",
        "translation": "They say they would put them when they passed away."
    },
    "135": {
        "startTime": 762.6,
        "endTime": 767.5,
        "transcript": "Maa-i-ggem tua-i yugnun piqa'aqluki.",
        "translation": "These days, they give them to people."
    },
    "136": {
        "startTime": 767.6,
        "endTime": 772.0,
        "transcript": "Assinruuq nutaan au͡gkucetun pivkenateng.",
        "translation": "It's better, unlike before."
    },
    "137": {
        "startTime": 772.1,
        "endTime": 774.0,
        "transcript": "Elpet-llu tua-i nallunritaten.",
        "translation": "You know them too."
    },
    "138": {
        "startTime": 779.5,
        "endTime": 795.5,
        "transcript": "Nasaurluut alerquutaitnek, alerquutekaatnek maa-i-rpak atu'urkaatnek camek qanqeryulliuten.",
        "translation": "Would you like to say anything about traditional instructions that girls should adhere to these days."
    },
    "139": {
        "startTime": 797.7,
        "endTime": 806.0,
        "transcript": "Nasaurluut-wa inerqutullrukait watqapiar-llu tan'gaurlull'er quuyuquluarautesqevkenaku.",
        "translation": "They used to admonish girls against ever smiling at a boy."
    },
    "140": {
        "startTime": 806.8,
        "endTime": 808.5,
        "transcript": "Arnaq-gguq tuquuguq.",
        "translation": "They say a woman leads to death."
    },
    "141": {
        "startTime": 808.6,
        "endTime": 813.0,
        "transcript": "Waten qanraqluteng: “Arnaq-gguq tuquuguq.”",
        "translation": "They said this: “A woman leads to death.”"
    },
    "142": {
        "startTime": 818.4,
        "endTime": 824.0,
        "transcript": "Wiinga tua-i atakumi-llu watqapiar mulusqeksaunii.",
        "translation": "They also told me never to stay out late in the evening."
    },
    "143": {
        "startTime": 826.9,
        "endTime": 835.0,
        "transcript": "Tuaten tua-i iciw' cat-llu carayagmun-llu teguciqnilua.",
        "translation": "They said, you know, that some creature would take me."
    },
    "144": {
        "startTime": 839.5,
        "endTime": 849.0,
        "transcript": "Elpet-mi? Tan'gaurluut-qaa maa-i-rpak niitarkaatnek piciatun qanruyutmek qanqeryuumiituten?",
        "translation": "What about you? Do you want to say any traditional wisdom that boys these days should hear?"
    },
    "145": {
        "startTime": 850.5,
        "endTime": 855.8,
        "transcript": "Tua-i-w' tau͡gaam alerquukaramnek ava-i iciw' qanruaresqemken?",
        "translation": "You know, I only told you about what instructions I had?"
    },
    "146": {
        "startTime": 856.2,
        "endTime": 863.0,
        "transcript": "Tua-i waten watli'rqan ayarurraq cingilek cukuliurutmek pitukevvut",
        "translation": "When [the season] became like this, the staff with a point that we call an ice spud"
    },
    "147": {
        "startTime": 864.0,
        "endTime": 867.0,
        "transcript": "Tua-i tamakunek piitesqevkenata.",
        "translation": "They told us to always have those."
    },
    "148": {
        "startTime": 867.4,
        "endTime": 871.4,
        "transcript": "Tumkaq-gguq apertutuat. Ilumun piciuqapiartuq.",
        "translation": "They say they show the way. Indeed, it's completely true."
    },
    "149": {
        "startTime": 872.0,
        "endTime": 874.0,
        "transcript": "Tua-i mamkilnguq nalluvkenaku.",
        "translation": "You will know thin spots."
    },
    "150": {
        "startTime": 876.0,
        "endTime": 880.9,
        "transcript": "Tua-i tuaten pitullruut au͡gkut ciulirneret.",
        "translation": "That's what those elders back then used to say."
    },
    "151": {
        "startTime": 881.0,
        "endTime": 887.8,
        "transcript": "Tua-i ava-i qanruartellrukemken ciungani ciunguluku ciumek tua-i alerquute[llret] au͡gkut.",
        "translation": "Before, the first thing I told you about was those people's instructions."
    },
    "152": {
        "startTime": 887.9,
        "endTime": 897.0,
        "transcript": "Ak'anun-llu wii qaillun-wa angtaluta elliraurtellruamta tua-i wangkutnek caqtarturluta.",
        "translation": "And for a long time, because we were orphaned when we were young, we did things ourselves."
    },
    "153": {
        "startTime": 897.1,
        "endTime": 903.0,
        "transcript": "Tua-i tau͡gaam yuk qanruyuterramikun yuuciqliniuq. Tua-i yuuciqliniuq.",
        "translation": "Evidently, a person will only live by his traditional wisdom. He will live [that way]."
    },
    "154": {
        "startTime": 903.4,
        "endTime": 908.0,
        "transcript": "Uitayukuni-ll' tua-i camek piinani.",
        "translation": "And if he's sedentary, he won't have anything."
    },
    "155": {
        "startTime": 908.1,
        "endTime": 913.4,
        "transcript": "Tua-i elpet-llu murilkelaqeten ilait maa-i caitelartut.",
        "translation": "You also observe these people who have nothing."
    },
    "156": {
        "startTime": 913.5,
        "endTime": 917.4,
        "transcript": "Apqiitnek qessaluteng tua-i callerkameggnek.",
        "translation": "They call that being too lazy to do their work."
    },
    "157": {
        "startTime": 918.7,
        "endTime": 927.8,
        "transcript": "Tua-i tau͡gken imna qessaniuqtarturalria tauna caileng'e'rmi tukuulriatun-gguq ayuquq.",
        "translation": "However, if one works hard despite not wanting do, even if he doesn't have anything, they say it's like he's rich."
    },
    "158": {
        "startTime": 927.9,
        "endTime": 933.0,
        "transcript": "Tua-i caitevkenani tua-i muralleraungraata-llu makunek.",
        "translation": "He has things, even these pieces of wood."
    },
    "159": {
        "startTime": 933.8,
        "endTime": 936.8,
        "transcript": "Tua-i ilumun piciuqapiartuq.",
        "translation": "Indeed, that's completely true."
    },
    "160": {
        "startTime": 938.8,
        "endTime": 942.9,
        "transcript": "Tua-i au͡g'urluum ava-i kinguqliata maa-i tangvallruamia",
        "translation": "Because that dear youngest one watched me"
    },
    "161": {
        "startTime": 943.0,
        "endTime": 950.5,
        "transcript": "Waten muraggarnek quyurtelartuq tua-i ellimenrilengramni tua-i tangvallruamia.",
        "translation": "He gathers wood like this even though he is not ordered to because he watched me."
    },
    "162": {
        "startTime": 954.4,
        "endTime": 957.0,
        "transcript": "Tua-i amllermek qanerpagkailngua.",
        "translation": "I don't have much else to say."
    },
    "163": {
        "startTime": 957.5,
        "endTime": 963.4,
        "transcript": "Mat'um-qaa nalliini elpeni makut ayagyuat akusrarneruut?",
        "translation": "These days, to you, are young people mischievous?"
    },
    "164": {
        "startTime": 963.5,
        "endTime": 965.0,
        "transcript": "Yaa. (Qaill'-wa pila[rtat].)",
        "translation": "Yes. (I don't know what they're doing.)"
    },
    "165": {
        "startTime": 965.1,
        "endTime": 969.0,
        "transcript": "Wiinga-w' tua au͡gna-w' tang… (Allayuurtut wii tangllemni.)",
        "translation": "Personally, that one, you see… (They're different from what I've seen.)"
    },
    "166": {
        "startTime": 969.1,
        "endTime": 974.6,
        "transcript": "Tau͡gaam allayuurtut maa-i mat'um-wa taangam, taangam pikai.",
        "translation": "They've become different now because of alcohol."
    },
    "167": {
        "startTime": 974.8,
        "endTime": 979.0,
        "transcript": "Imumitun ayuqenriqapiartut. Elpet tua-i nallunritaten.",
        "translation": "They're nothing like a long time ago. You know them."
    },
    "168": {
        "startTime": 979.5,
        "endTime": 985.5,
        "transcript": "Tua-i yuk-llu una cavkenani tarrilluni, ak'a-ll' tuquqerluni taangam pitaqluku.",
        "translation": "And a person wanders around for no reason, and he's immediately dead at the hands of alcohol."
    },
    "169": {
        "startTime": 986.0,
        "endTime": 989.0,
        "transcript": "Qanqataunateng tuaten. (Imumitun pinrirtut).",
        "translation": "They also speak without thinking. (They're not like before)."
    },
    "170": {
        "startTime": 990.7,
        "endTime": 996.7,
        "transcript": "Yuut tamarmeng nallunritait makut ciulirneret waten pilauciit.",
        "translation": "These elders know that every person does this."
    },
    "171": {
        "startTime": 997.0,
        "endTime": 1000.0,
        "transcript": "Tua-i taangam mat'um cukatqapiararai.",
        "translation": "Alcohol is killing them off very quickly."
    },
    "172": {
        "startTime": 1000.5,
        "endTime": 1004.7,
        "transcript": "Ilait-llu malikluteng tua-i ataucikun tuqurnaurtut.",
        "translation": "And some go together and die at once."
    },
    "173": {
        "startTime": 1005.9,
        "endTime": 1009.4,
        "transcript": "Wall' kill'uteng, tua-i kit'erpallurluteng-wa pilalriit.",
        "translation": "Or they drown, they mostly drown."
    },
    "174": {
        "startTime": 1009.5,
        "endTime": 1014.5,
        "transcript": "Ilait-llu maa-i-am allayuurtellret ukaqvanernek tuqucaurrluteng.",
        "translation": "And some who have become different recently kill [themselves]."
    },
    "175": {
        "startTime": 1014.6,
        "endTime": 1018.5,
        "transcript": "Inerquutnguyaaquq man'a tua-i ellminek tuqutellerkaq.",
        "translation": "Suicide is admonished against."
    },
    "176": {
        "startTime": 1019.0,
        "endTime": 1027.0,
        "transcript": "Arnaq ayagneqluku tuqutaqluteng. (Yaani man'a ella piunriqan tamakut anirtuumangaitut ellmeggnek tuqutellret.)",
        "translation": "They kill [themselves] over a woman. (Someday when the world ends, those who've committed suicide will not be saved.)"
    },
    "177": {
        "startTime": 1027.8,
        "endTime": 1031.9,
        "transcript": "Tua-i yuk nangtequrang'e'rmi tua-i uitali.",
        "translation": "Even if a person is suffering, may [s]he stay."
    },
    "178": {
        "startTime": 1032.0,
        "endTime": 1040.0,
        "transcript": "Ayuqniange'rmi-llu tua-i ilamitun pinrilnge'rmi tua-i ilani tupagaqata tupalartut.",
        "translation": "And even if [s]he wants what others have despite not being like them, his peers wake up when they wake up."
    },
    "179": {
        "startTime": 1040.5,
        "endTime": 1045.5,
        "transcript": "Tua-i wiinga tua-i waten tua-i waniw' tangrrarpenga.",
        "translation": "Now, you see me here."
    },
    "180": {
        "startTime": 1045.6,
        "endTime": 1049.0,
        "transcript": "Yuugua tua-i tua-i waten tua-i.",
        "translation": "I am alive like this."
    },
    "181": {
        "startTime": 1049.5,
        "endTime": 1054.5,
        "transcript": "Tau͡gaam uku'urluuk waniw' aulukeqtarturalaranka.",
        "translation": "But I take care of these two here."
    },
    "182": {
        "startTime": 1055.0,
        "endTime": 1059.9,
        "transcript": "Maa-i tau͡gaam ciunganitun piscii[galilua]. Akleng, kuvyassiyaanrirlua-llu.",
        "translation": "But now, I can't do what I used to before. Pity, I don't go drift netting much anymore too."
    },
    "183": {
        "startTime": 1060.0,
        "endTime": 1065.5,
        "transcript": "Maa-i neqem nalliini tua-i ataucirqumek iliini-ll' aipiriqerlua.",
        "translation": "Now, during fishing season, I go once and sometimes a second time."
    },
    "184": {
        "startTime": 1065.6,
        "endTime": 1075.0,
        "transcript": "Tau͡gaam imuggun petugarrarkun tua-i tamaa-i neqnek quyurutkelallqa, neqrarnek-wa.",
        "translation": "But I use a tethered net that I used to use for fishing, at least small fish."
    },
    "185": {
        "startTime": 1078.3,
        "endTime": 1080.0,
        "transcript": "Man'a-qaa piciatun elpenek…",
        "translation": "Does this, from you…"
    },
    "186": {
        "startTime": 1080.5,
        "endTime": 1083.5,
        "transcript": "Huh? (Okay, keep going.)",
        "translation": "Huh? (Okay, keep going.)"
    },
    "187": {
        "startTime": 1084.0,
        "endTime": 1089.0,
        "transcript": "Man'a-qaa elpetek kiuyukuniu kiuniaraa.",
        "translation": "For this, whichever of you2 can answer this."
    },
    "188": {
        "startTime": 1090.0,
        "endTime": 1105.5,
        "transcript": "Wangkuta Yugni nerangnaqsaraq atulalput atuqengaput-llu watua mat'um nalliini cagmarnarqenrituq-qaa?",
        "translation": "Should we Yupiit not lose our past subsistence that we also use today?"
    },
    "189": {
        "startTime": 1106.0,
        "endTime": 1108.3,
        "transcript": "Cagmagnarqenrituq ilumun.",
        "translation": "It truly should not be lost."
    },
    "190": {
        "startTime": 1108.4,
        "endTime": 1114.4,
        "transcript": "Aren tua-i yuum angussagcuukarani, atam imkut ava-i qanrutenritliaten.",
        "translation": "My goodness, what hunting implements a person has, I didn't tell you about them, you see."
    },
    "191": {
        "startTime": 1114.5,
        "endTime": 1121.5,
        "transcript": "Unisteḿa imkut taluyarraat yuugaqamiki tang qulvaqernaurai.",
        "translation": "When my late father removed his little fish nets, he would put them up."
    },
    "192": {
        "startTime": 1121.6,
        "endTime": 1123.0,
        "transcript": "Tua-i piciryaraqluku.",
        "translation": "That was his custom."
    },
    "193": {
        "startTime": 1123.9,
        "endTime": 1130.0,
        "transcript": "Maa-i-ll' wii, maa-i wii tamakut aturciigalkeka. Tangvallruyaaqaqa.",
        "translation": "And now, I can't do those. I watched him."
    },
    "194": {
        "startTime": 1133.4,
        "endTime": 1149.3,
        "transcript": "Makut-qaa man'a nerangnaqsararput aipaimta alerquutait cagmarcetellriatun pingevkaraa?",
        "translation": "Is our [Caucasian] counterparts' instructions [or laws] making it like our subsistence is being lost?"
    },
    "195": {
        "startTime": 1150.0,
        "endTime": 1151.9,
        "transcript": "Qaill'-wa piat.",
        "translation": "I'm not sure what going on with them."
    },
    "196": {
        "startTime": 1152.0,
        "endTime": 1156.7,
        "transcript": "Ilait-wa maa-i, aren taluyateng-llu yuuyuirulluki.",
        "translation": "Some people now, my goodness, they don't remove their fish traps too."
    },
    "197": {
        "startTime": 1156.8,
        "endTime": 1159.0,
        "transcript": "Atam qanpagalluku qanpagaluten.",
        "translation": "Speak loudly to him."
    },
    "198": {
        "startTime": 1159.5,
        "endTime": 1164.0,
        "transcript": "Atam wii qaskilnguut taringekluten taringetuanka.",
        "translation": "You see, I don't completely understand when people speak quietly."
    },
    "199": {
        "startTime": 1166.8,
        "endTime": 1174.0,
        "transcript": "Ak'a-qaa tamaani kencik'lallruit tegganret?",
        "translation": "Back then, did they respect elders?"
    },
    "200": {
        "startTime": 1175.0,
        "endTime": 1176.5,
        "transcript": "Pissuuteteng?",
        "translation": "Their tools?"
    },
    "201": {
        "startTime": 1177.0,
        "endTime": 1178.5,
        "transcript": "Nuu. (Aa-a.)",
        "translation": "No. (Okay.)"
    },
    "202": {
        "startTime": 1178.8,
        "endTime": 1182.6,
        "transcript": "Tua-i-wa tegganret, tegganret-qaa takaqelallruit?",
        "translation": "Elders, did they respect elders?"
    },
    "203": {
        "startTime": 1182.7,
        "endTime": 1192.5,
        "transcript": "Takarnarqellruut imkut ciuqliit au͡gkut wangkutun ayuqenrilnguut, ciuqvallret au͡gkut.",
        "translation": "Those people back then who are not like us, those a long time ago, were intimidating."
    },
    "204": {
        "startTime": 1193.7,
        "endTime": 1199.5,
        "transcript": "Tua-i elpet-llu nallunrilketen tua-i piyarait.",
        "translation": "You also know their customs."
    },
    "205": {
        "startTime": 1200.0,
        "endTime": 1202.5,
        "transcript": "Tua-i qaill' pisciiganaki.",
        "translation": "We couldn't treat them in any [bad] way."
    },
    "206": {
        "startTime": 1204.0,
        "endTime": 1211.4,
        "transcript": "Takarnaqluteng. Itellriami-ll', itellriani-ll' enemun kiavaqerciiganani.",
        "translation": "They were intimidating. And when going into a house, they couldn't go further inside."
    },
    "207": {
        "startTime": 1211.5,
        "endTime": 1216.0,
        "transcript": "Kiavaqertesciigat'lallruunga inerciigalnge'rma.",
        "translation": "I couldn't go inside even though I was mischievous."
    },
    "208": {
        "startTime": 1217.5,
        "endTime": 1222.5,
        "transcript": "Tua-i caperrsuglua kiavallerkamnek uani amiigem taqu͡rani.",
        "translation": "I was hestitant to go inside out by the door."
    },
    "209": {
        "startTime": 1223.5,
        "endTime": 1226.5,
        "transcript": "Kiavaasqaqatnga tau͡gaam kiavaraqlua.",
        "translation": "I would only go inside when they told me to."
    },
    "210": {
        "startTime": 1227.4,
        "endTime": 1232.0,
        "transcript": "Maa-i kiaggun enem iquakun anengnaqtuut.",
        "translation": "Now, they try to go out at the end of the house inside."
    },
    "211": {
        "startTime": 1237.5,
        "endTime": 1246.5,
        "transcript": "Mat'um-qaa nalliini man'a Yugcetun qaneryararput cagmarnarqenrituq ciin-llu makunun ayagyuanun? (Yaa.)",
        "translation": "These days, should our young people keep from losing our Yup'ik language and why? (Yes.)"
    },
    "212": {
        "startTime": 1246.6,
        "endTime": 1247.9,
        "transcript": "Ciin cagmarnarqenrita?",
        "translation": "Why shouldn't we lose it?"
    },
    "213": {
        "startTime": 1248.0,
        "endTime": 1257.6,
        "transcript": "Tua-i-wa makut tang qitevquralriit Kass'atun qanruqu'urqait tuar tang usvituvlaalalriit-llu.",
        "translation": "You see, these people who speak English, the ones they speak [only] in English to, seem like they're not completely wise."
    },
    "214": {
        "startTime": 1257.7,
        "endTime": 1264.0,
        "transcript": "Wiinga-w' ukut tutgara'urluunka Vera-m yui qanruteqtalaryaaqluku aaniit",
        "translation": "My grandchildren here, Vera's children, I tell their mother"
    },
    "215": {
        "startTime": 1264.5,
        "endTime": 1270.4,
        "transcript": "“Atam Yugcetun qalarut'larki taringeluaqerluten taringelarnauraatgen.”",
        "translation": "“Look, speak to them in Yup'ik so that they'll completely understand you.”"
    },
    "216": {
        "startTime": 1275.0,
        "endTime": 1281.0,
        "transcript": "Man'a-qaa Yugtun qalarcaraq elicungcarturlitgu elitnaurvigni?",
        "translation": "Shoud, they teach this Yup'ik language in schools?"
    },
    "217": {
        "startTime": 1281.1,
        "endTime": 1283.5,
        "transcript": "Yaa, please.",
        "translation": "Yes, please."
    },
    "218": {
        "startTime": 1286.8,
        "endTime": 1287.4,
        "transcript": "Tua-i-qaa?",
        "translation": "Is that all?"
    },
    "219": {
        "startTime": 1288.0,
        "endTime": 1289.5,
        "transcript": "Two minutes left on this tape. (Okay.)",
        "translation": "Two minutes left on this tape. (Okay.)"
    },
    "220": {
        "startTime": 1290.0,
        "endTime": 1291.0,
        "transcript": "Tua-i-q' taq'ukuk?",
        "translation": "Are we2 done?"
    },
    "221": {
        "startTime": 1291.1,
        "endTime": 1293.0,
        "transcript": "Tua-i-wa taqsaaqellilriakut. (Aa-a, quyana.)",
        "translation": "We're done. (Okay, thank you.)"
    },
    "222": {
        "startTime": 1296.0,
        "endTime": 1299.9,
        "transcript": "Yaa, let's see. (Tua-i kitak'…)",
        "translation": "Okay, let's see. (Well now…)"
    },
    "223": {
        "startTime": 1300.0,
        "endTime": 1302.9,
        "transcript": "Una-qaa, una-qaa Kuiggluk nutem maantellruuq?",
        "translation": "Has Kwethluk always been here?"
    },
    "224": {
        "startTime": 1303.0,
        "endTime": 1306.0,
        "transcript": "Aren, maaten ellangua Kuiggluk wanlluni.",
        "translation": "My goodness, Kwethluk was here in my earliest memories."
    },
    "225": {
        "startTime": 1306.8,
        "endTime": 1311.0,
        "transcript": "Wangkuta uantellruukut uaqvani, enet-wa qavcirraan.",
        "translation": "We were far downriver, and there were only several houses."
    },
    "226": {
        "startTime": 1311.1,
        "endTime": 1313.0,
        "transcript": "Yugyallrunrituq waten.",
        "translation": "It wasn't populous like this."
    },
    "227": {
        "startTime": 1314.5,
        "endTime": 1318.0,
        "transcript": "Tua-i avani kipusviim ing'um nalliini kanani.",
        "translation": "It was at the time of the store down over there."
    },
    "228": {
        "startTime": 1319.5,
        "endTime": 1323.0,
        "transcript": "Aterpagtaqluta Kiaqlirmiunek.",
        "translation": "The called us the Upriver People."
    },
    "229": {
        "startTime": 1323.5,
        "endTime": 1326.0,
        "transcript": "Waniw' una Kuigglugmiunguqapiartuq.",
        "translation": "This here is the original Kwethluk."
    },
    "230": {
        "startTime": 1327.5,
        "endTime": 1332.0,
        "transcript": "Wiinga-llu Iigmi ellangellrulrianga.",
        "translation": "My earliest memories are in Eek."
    },
    "231": {
        "startTime": 1334.0,
        "endTime": 1342.0,
        "transcript": "Ellangnemkun-llu wagg'uq au͡gkunun Apruka'armiunun atrarluta wagg'uq…",
        "translation": "And in my earliest memories, we were going down to what they called Aparuka'armiut, as in…"
    }
};